<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>修改密码</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <el-form-item label="当前密码:" prop="old_pwd">
          <el-col :span="20">
            <el-input style="width: 400px;" placeholder="请输入英文或字符或数字，不支持中文" maxlength="30" v-model="form.old_pwd"
              :show-password="true" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="新密码:" prop="user_pwd">
          <el-col :span="20">
            <el-input style="width: 400px;" placeholder="请输入英文或字符或数字，不支持中文" maxlength="30" v-model="form.user_pwd"
              :show-password="true" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="确认密码:" prop="user_pwd1">
          <el-col :span="20">
            <el-input style="width: 400px;" placeholder="请输入英文或字符或数字，不支持中文" maxlength="30" v-model="form.user_pwd1"
              :show-password="true" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
//  * 参数：type 类别(1积分商品 2非卖品)，pid 商品id(新增为空，编辑不为空)，name 商品名，img_name 上传后商品图片，detail_img 上传后商品介绍图片，
// 	 * 		price 所需积分，stock_num 库存，rank 排序值(可为空)，status 发布状态(0停用 1启用)，option 操作(1新增 2编辑)
export default {
  name: 'authorchange',
  data() {
    return {
			nodeLimtList: [],
      form: {
        uid: '',
        old_pwd: '',
        user_pwd: '',
        user_pwd1: '',
      },
      rules: {
        old_pwd: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'change',
          },
        ],
        user_pwd: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'change',
          },
        ],
        user_pwd1: [
          {
            required: true,
            message: '请确认新密码',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id ? this.form.uid = this.query.id : ''
		this.checkUrlFn()
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateUserPwd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateUserPwd() {
      if (this.form.user_pwd1 != this.form.user_pwd) {
        this.$message.error('两次输入密码不同！')
        return false
      }
      // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/;
      // if (!reg.test(this.form.user_pwd)) {
      //   this.$message.error('密码必须为包含大小写字母、英文特殊字符、数字的至少8位字符')
      //   return false         
      // }
      else {
        api.updateUserPwd(this.form).then((res) => {
          this.$message.success(res)
          this.$router.go(-1)
        })
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: $c;
}

.el-checkbox-group {
  display: flex;
  flex-flow: row wrap;

  .el-checkbox {
    width: 40%;
    flex: none;
    padding: 10px 0;
  }
}

.el-form-item {
  margin-bottom: 30px;
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .apage {
    background: #f2f2f2;
    padding: 8px;
    text-align: right;
  }

  .el-select {
    margin-right: 20px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    height: 36px;
    line-height: 36px;
    border: none;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
  }

  .table {
    @extend %box;
    padding: 30px;
  }

  .line {
    text-align: center;
  }

  .group-head {
    font-size: 18px;
    font-weight: 700;
    padding-left: 10px;
    color: #10456d;
  }
}
</style>
